import script from "./comment.vue?vue&type=script&lang=ts&setup=true"
export * from "./comment.vue?vue&type=script&lang=ts&setup=true"

import "./comment.vue?vue&type=style&index=0&id=5d4f60e1&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d4f60e1"]])

export default __exports__